import 'css-chunksrc/client/scenes/projectExpenseRemoval/styles.scss';export default {
  "header": "_header_17shg_1",
  "main": "_main_17shg_5",
  "group": "_group_17shg_12",
  "text": "_text_17shg_16",
  "buttons": "_buttons_17shg_21"
};